/**
Copyright (c) 2023, 2024, 2025 Amica Corp.
All rights reserved.

This source code, resulting binary forms, and associated documentation
(the "Software") may only be used, modified, or distributed, with or
without modification, under the terms of a written license agreement
with Amica Corp. (the "License"). All rights to manufacture, use,
redistribute, or sell anything described herein, in whole or in part,
are granted only as explicitly permitted by such License. The receipt
or possession of the Software does not convey any of these rights.

This Software is provided "AS IS," WITHOUT WARRANTY OF ANY KIND, express
or implied, including but not limited to the implied warranties of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.

For additional terms, see https://amica.cloud/software-copyright/
 */

/* eslint-disable  */
import { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Loader } from 'modules/common/components';
import { selectLoader } from 'modules/visual-filter/selectors';
import { selectOrganizationId } from 'modules/common/auth/selectors';
import PAGINATION from 'modules/common/constants/pagination-limits';
import { Card, CardContent, Grid, Typography, Button } from '@mui/material';
import { withTheme } from '@emotion/react';
import { visualFilterActions } from 'modules/visual-filter/slice';
import { isEmpty } from 'modules/common/helpers/object';
import VisualFilterTable from '../visual-filter-table';
import UpdateVisualFilterForm from '../update-visual-filter';
import AddVisualFilterForm from '../add-visual-filter';

/**
 * Visual filter view to add, edit and delete visual filters
 * @param {*} param0
 * @returns
 */
const VisualFilterView = ({ theme }) => {
  const dispatch = useDispatch();
  //
  const organizationId = useSelector(selectOrganizationId);
  const loading = useSelector(selectLoader);
  //
  const [selectedFilterId, setSelectedFilterId] = useState({});
  const [open, setOpen] = useState(false);
  const [show, isShow] = useState(false);
  //
  useEffect(() => {
    const query = `limit=${PAGINATION.VISUAL_FILTERS_PER_PAGE_COUNT}`;
    dispatch(
      visualFilterActions.getVisualFilters({
        organizationId,
        query,
      })
    );
  }, [organizationId]);
  //
  useEffect(() => {
    if (!isEmpty(selectedFilterId)) {
      dispatch(
        visualFilterActions.getVisualFilterById({
          organizationId,
          selectedFilterId,
        })
      );
    }
  }, [organizationId, selectedFilterId]);
  //
  return (
    <Loader loading={loading}>
      <Card>
        <CardContent sx={{ backgroundColor: theme.palette.background.default }}>
          <Grid container direction="row" justifyContent="space-between" pb={4}>
            <Typography variant="h3">Configure Visual Filters</Typography>
            <Button
              disabled={show}
              variant="contained"
              color="primary"
              onClick={() => setOpen(true)}
            >
              Add Visual Filter
            </Button>
          </Grid>
          <Grid container direction="row" spacing={2} justifyContent="space-between">
            <Grid item sx={{ flexGrow: 1, flexBasis: 1 }}>
              <VisualFilterTable isShow={isShow} setSelectedVisualId={setSelectedFilterId} />
            </Grid>
            {!isEmpty(selectedFilterId) && (
              <UpdateVisualFilterForm
                show={show}
                isShow={isShow}
                visualFilterId={selectedFilterId}
              />
            )}
          </Grid>
        </CardContent>
        <AddVisualFilterForm open={open} onClose={() => setOpen(false)} />
      </Card>
    </Loader>
  );
};
//
export default withTheme(VisualFilterView);
